//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// responsive
import { M, MMinus, MPlus, T } from "../../utils/MT";

// component
import Header from "../../component/common/Header";
import Login from "./components/Login";
import DefaultPop from "../../component/popup/DefaultModal";
import BasicBtn from "../../component/button/BasicBtn";
import Footer from "../../component/common/Footer";
import InnerCon from "../../component/layouts/InnerCon";

export default function LoginPage() {
    // 모달리스트
    // 1. 비밀번호 찾기 팝업
    const [PwModal, setPwModal] = useState(false);
    // 2. 비밀번호찾기 성공 팝업
    const [SucessModal2, setSucessModal2] = useState(false);

    // 비밀번호 찾기 액티브 스타일
    const [name1, setName1] = useState(false);
    const [email2, setEmail2] = useState(false);

    // 1. 비밀번호 찾기 팝업
    const FindPwModal = () => {
        return (
            <>
                <FindPwContent>
                    <FindTitle>비밀번호 찾기</FindTitle>
                    <FindSubTitle>
                        계정의 이메일 주소를 입력하면
                        <br />
                        비밀번호 재설정을 위한 이메일을 보내 드립니다.
                    </FindSubTitle>
                    <GrayLine></GrayLine>
                    <InputList margin20 active={name1.length > 0}>
                        <InputBox
                            type="text"
                            placeholder="이름을 입력하세요."
                            onChange={(e) => {
                                setName1(e.target.value);
                            }}
                            required
                        />
                    </InputList>
                    <InputList active={email2.length > 0}>
                        <InputBox
                            type="email"
                            placeholder="이메일을 입력해주세요."
                            onChange={(e) => {
                                setEmail2(e.target.value);
                            }}
                            required
                        />
                    </InputList>
                    <FindpwdBtn>
                        <BasicBtn onClick={onClickFindPw} text="확인" bgWhite={true} />
                    </FindpwdBtn>
                </FindPwContent>
            </>
        );
    };

    const onClickFindPw = () => {
        setPwModal(false);
        setSucessModal2(true);
    };

    // 2. 비밀번호찾기 성공 팝업
    const SucessPwModal = () => {
        return (
            <>
                <SucessContent>
                    <FindTitle>비밀번호 찾기</FindTitle>
                    <SucessBox>
                        <SucessText2>
                            이메일&nbsp;<span>sindoh1234@email.com</span>&nbsp;로 <br /> 이메일 전송 완료하였습니다.
                        </SucessText2>
                    </SucessBox>
                    <FindedpwdBtn>
                        <BasicBtn onClick={() => setSucessModal2(false)} text="닫기" gray={true} />
                    </FindedpwdBtn>
                </SucessContent>
            </>
        );
    };

    return (
        <>
            <Wrap>
                <Header />
                <InnerCon>
                    <Login setPwModal={setPwModal} setSucessModal2={setSucessModal2} />
                </InnerCon>
                <Footer />
            </Wrap>
            {/* 1. 비밀번호 찾기 팝업 */}
            {PwModal && (
                <DefaultPop
                    closeModal={() => {
                        setPwModal(false);
                    }}
                    contents={FindPwModal}
                />
            )}
            {/* 2. 비밀번호찾기 성공 팝업 */}
            {SucessModal2 && (
                <DefaultPop
                    closeModal={() => {
                        setSucessModal2(false);
                    }}
                    contents={SucessPwModal}
                />
            )}
        </>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;

// 팝업 스타일링
// 비밀번호 찾기 모달
const FindTitle = styled.h2`
    font-size: calc(100vw * (30 / 1920));
    font-family: "Noto-R";
    text-align: center;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const FindSubTitle = styled.p`
    margin: calc(100vw * (20 / 1920)) 0 calc(100vw * (30 / 1920));

    font-size: calc(100vw * (15 / 1920));
    font-family: "Noto-R";
    text-align: center;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (20 / 1300)) 0 calc(100vw * (30 / 1300));

        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(9)} 0 ${M(30)};

        font-size: ${M(14)};
    }
`;
const GrayLine = styled.p`
    width: 100%;
    height: 1px;
    /* margin-top: calc(100vw * (30 / 1920)); */

    background: #dddddd;

    @media screen and (max-width: 1300px) {
        /* margin-top: calc(100vw * (30 / 1300)); */
    }

    @media screen and (max-width: 900px) {
        width: ${M(160)};
        margin: 0 auto;
        /* margin-top: $s{M(30)}; */

        /* margin: ${M(30)} auto 0; */
    }
`;
const FindIdContent = styled.div`
    width: calc(100vw * (400 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (400 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;

const SucessContent = styled(FindIdContent)``;
const SucessBox = styled.div`
    width: 100%;
    margin: calc(100vw * (20 / 1920)) 0;
    padding: calc(100vw * (40 / 1920)) calc(100vw * (10 / 1920));

    background-color: #fafafa;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (20 / 1300)) 0;
        padding: calc(100vw * (40 / 1300)) calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(285)};
        margin: ${M(30)} auto;
        padding: ${M(30)} ${M(10)};
    }
`;

const FindPwContent = styled(FindIdContent)``;

const FindpwdBtn = styled.div`
    margin-top: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(300)};
        margin-top: ${M(45)};

        margin: ${M(45)} auto 0;
    }
`;
const FindedpwdBtn = styled(FindpwdBtn)`
    @media screen and (max-width: 900px) {
        width: ${M(300)};
        margin-top: ${M(45)};

        margin: 0 auto;
    }
`;
const InputList = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: calc(100vw * (50 / 1920));
    border-radius: 4px;
    background-color: #fafafa;
    overflow: hidden;
    padding: calc(100vw * (12 / 1920));
    margin-top: calc(100vw * (25 / 1920));
    /* margin-bottom: calc(100vw * (25 / 1920)); */

    ${({ active }) => {
        return active ? `border: 1px solid #FF5F00;` : `border: 1px solid #FAFAFA;`;
    }}

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (50 / 1300));
        padding: calc(100vw * (12 / 1300));
        margin-top: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(45)};
        padding: ${M(12)} ${M(15)};
        margin-top: ${M(10)};

        ${({ margin20 }) => {
            return (
                margin20 &&
                `
                    margin-top: ${M(20)};
                `
            );
        }}
    }
`;
const InputBox = styled.input`
    width: 100%;
    height: 100%;
    font-size: calc(100vw * (15 / 1920));
    color: #222222;
    &::placeholder {
        color: #dddddd;
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
const SucessText2 = styled.p`
    text-align: center;
    word-break: break-all;

    font-size: calc(100vw * (14 / 1920));

    & span {
        display: contents;
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
